import gql from 'graphql-tag';

let featuresFragment = gql`
  fragment FeaturesInfo on FeaturesInfo {
    totalDays
    price
    features {
      name
      finished
    }
  }
`;

export let FETCH_SHEET_QUERY = gql`
  query FetchSheetQuery {
    fetchSheet {
      projectName
      projectDaysRemaining
      totalMandays
      sheetId
      estimatedTotalMandays
      estimatedDeliveryDate
      estimatedMandaysRemaining
      estimatedProgress
      projectStartDate
      currency
      originalFeatures {
        ...FeaturesInfo
      }
      overdueFeatures {
        ...FeaturesInfo
      }
      additionalFeatures {
        ...FeaturesInfo
      }
      billing {
        paidInvoices
        remainingInvoices
        outstandingInvoices
      }
    }
  }
  ${featuresFragment}
`;

export let EXPORT_CSV_QUERY = gql`
  query GenerateJSON {
    generateJSON {
      detail {
        featureName
        description
        resources
        mandaysSpent
        startDate
        finishDate
      }
    }
  }
`;

export let SPECIAL_CSV_QUERY = gql`
  query GenerateDBO {
    generateDBO {
      detail {
        week
        days
        date
        name
        resource
        task
        mandays
      }
    }
  }
`;
